import type { IStringTool } from "../core/IStringTool.ts"; // Переконайтесь, що шлях правильний

/**
 * Input for parsing the transform string to extract scale.
 */
interface TransformParserInput {
  /** CSS transform string (e.g., "matrix(0.5, 0, 0, 0.5, 10, 20)", "scale(0.5)", "none"). */
  value: string;
}

/**
 * Parses a CSS transform string to extract the primary scale factor.
 * Assumes uniform scale or extracts the X-axis scale factor from matrix/scale functions.
 */
export default class TransformScaleParserTool
  implements IStringTool<TransformParserInput, number> // Output is a number
{
  /**
   * Processes the transform string and extracts the scale factor.
   * @returns Numeric scale factor (defaults to 1 if no scale transform is found or parsing fails).
   */
  process({ value }: TransformParserInput): number {
    const defaultScale = 1;
    const str = value?.trim();

    if (!str || str === 'none') {
      return defaultScale;
    }
    try {
      if (str.startsWith('matrix(')) {
        const matrixValues = str.match(/matrix\(([^)]+)\)/);
        if (matrixValues && matrixValues[1]) {
          const matrixNumbers = matrixValues[1].split(',').map(s => parseFloat(s.trim()));
          if (matrixNumbers.length >= 1 && !isNaN(matrixNumbers[0])) {
            return matrixNumbers[0];
          }
        }
      }

      if (str.startsWith('scale(')) {
        const scaleValue = str.match(/scale\(([^)]+)\)/);
        if (scaleValue && scaleValue[1]) {
          const scaleNumbers = scaleValue[1].split(',').map(s => parseFloat(s.trim()));
          if (scaleNumbers.length >= 1 && !isNaN(scaleNumbers[0])) {
            return scaleNumbers[0];
          }
        }
      }

       if (str.startsWith('scaleX(')) {
        const scaleXValue = str.match(/scaleX\(([^)]+)\)/);
        if (scaleXValue && scaleXValue[1]) {
          const scaleNumber = parseFloat(scaleXValue[1].trim());
          if (!isNaN(scaleNumber)) {
            return scaleNumber;
          }
        }
      }

       if (str.startsWith('scale3d(')) {
         const scale3dValue = str.match(/scale3d\(([^)]+)\)/);
         if (scale3dValue && scale3dValue[1]) {
             const scaleNumbers = scale3dValue[1].split(',').map(s => parseFloat(s.trim()));
             if (scaleNumbers.length >= 1 && !isNaN(scaleNumbers[0])) {
                 return scaleNumbers[0]; // Повертаємо sx
             }
         }
       }

       if (str.startsWith('matrix3d(')) {
           const matrix3dValues = str.match(/matrix3d\(([^)]+)\)/);
           if (matrix3dValues && matrix3dValues[1]) {
               const matrixNumbers = matrix3dValues[1].split(',').map(s => parseFloat(s.trim()));
               if (matrixNumbers.length >= 1 && !isNaN(matrixNumbers[0])) {
                   return matrixNumbers[0];
               }
           }
       }

    } catch (error) {
      console.error(`Error parsing transform string "${str}":`, error);
      return defaultScale;
    }

    return defaultScale;
  }
}
